export interface UnloadType {
  unloadTypeCode: string;
  unloadTypeDesc: string;
  unloadTypeId: number;
}
